const CHALLENGE_TYPES = {
  DISH_TYPE: 'DISH_TYPE',
  CUISINE_TYPE: 'CUISINE_TYPE',
}

export default CHALLENGE_TYPES
